import { 
  PROFILE_ERROR, 
  PROFILE_SUCCESS, 
  EDIT_PROFILE, 
  RESET_PROFILE_FLAG,
  GET_USER_PROFILE_INFO,
  GET_USER_PROFILE_INFO_SUCCESS,
  GET_USER_PROFILE_INFO_FAIL,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAIL
} from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  userProfileInfo: null,
  loading: false,
  isUpdateSuccess: false,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state };
      break;
    case PROFILE_SUCCESS:
      state = { ...state, success: action.payload };
      break;
    case PROFILE_ERROR:
      state = { ...state, error: action.payload };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null, isUpdateSuccess: false };
      break;
    
    // New user profile cases
    case GET_USER_PROFILE_INFO:
      state = { ...state, loading: true };
      break;
    case GET_USER_PROFILE_INFO_SUCCESS:
      state = { ...state, loading: false, userProfileInfo: action.payload, error: "" };
      break;
    case GET_USER_PROFILE_INFO_FAIL:
      state = { ...state, loading: false, error: action.payload };
      break;
    case UPDATE_USER_PROFILE:
      state = { ...state, loading: true, isUpdateSuccess: false };
      break;
    case UPDATE_USER_PROFILE_SUCCESS:
      state = { ...state, loading: false, success: action.payload, isUpdateSuccess: true, error: "" };
      break;
    case UPDATE_USER_PROFILE_FAIL:
      state = { ...state, loading: false, error: action.payload, isUpdateSuccess: false };
      break;
    
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
